export function approvedDataHandler(payload) {
  const { data, status, checkBoxAction, checkedData } =
    payload;
  return data?.data?.data.map((item) => {
    return { ...item, status, checkBoxAction: checkBoxAction(item, checkedData) };
  });
}
